module.exports = __webpack_public_path__ + "img/chadle_adv_13.f0132d34.png";